import gql from "graphql-tag"

const favoriteFragment = gql`
  fragment favoriteFragment on FavoritesFile {
    id
    name
    description
    favoriteType
    slug
    metadata {
      modelDisplayName
      bookmark
      searchKeyword
      vendor
      sector
      reportType
      reportId
      imageURL
    }
  }
`

const getViewerFolders = gql`
  query {
    viewer {
      id
      unsortedFavorites: favorites(unsorted: true) {
        ...favoriteFragment
      }
      folders {
        favoriteCount
        id
        name
        favorites(limit: 3) {
          ...favoriteFragment
        }
      }
    }
  }
  ${favoriteFragment}
`

const getRecentFavorites = gql`
  query {
    searchFavorites(
      limit: 4
      sort: { field: lastAccessedDate, direction: desc }
    ) {
      ...favoriteFragment
    }
  }
  ${favoriteFragment}
`

const searchFavorites = gql`
  query searchFavorites($keyword: String) {
    searchFavorites(keyword: $keyword) {
      ...favoriteFragment
    }
  }
  ${favoriteFragment}
`

export { getViewerFolders, getRecentFavorites, searchFavorites }
